import './computerVision.css';
import React from 'react';
import Typography from '@material-ui/core/Typography';
//import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { FirestoreService } from '../../services/firestoreService';
import ServiceMediaCard from '../../cards/serviceMediaCard.js';

function computerVision(props){
//  const theme = createTheme();
//  theme.typography.h4 = {
//    color: "#b97cfd"
//};
  return (
    <div className="ComputerVision">
      <body className="ComputerVision-body">
    {/*  <ThemeProvider theme={theme}> */}
      <Typography variant="h4">
      Image Recognition Services
      </Typography>
    {/*  </ThemeProvider> */}
      <div className="ComputerVision-imageRecognition">

      <div className="ComputerVision-card">
      <ServiceMediaCard
      header=" Custom Image Recognition :"
      description=" We do Custom Image based AI tasks as per your requirement. "
      imageUrl='https://st4.depositphotos.com/1269954/21201/v/380/depositphotos_212012556-stock-illustration-custom-made-rubber-stamp.jpg'
      alt="Label Detection"/>
      </div>

      <div className="ComputerVision-card">
      <ServiceMediaCard
      header=" Personal Protective Equipment (PPE) detection :"
      description=" Automatically detect Personal Protective Equipment (PPE) such as face covers, head covers, and hand covers on persons in images. "
      imageUrl='https://d2908q01vomqb2.cloudfront.net/f1f836cb4ea6efb2a0b1b99f41ad8b103eff4b59/2020/10/14/1-Person.jpg'
      alt="(PPE) detection"/>
      </div>

      <div className="ComputerVision-card">
      <ServiceMediaCard
      header=" Label detection :"
      description=" We label objects, concepts, scenes, and actions in your images with a confidence score. "
      imageUrl='https://d1.awsstatic.com/product-marketing/Rekognition/Label-detection.b3858b2903ec631bef4603b6689848ed342a4400.png'
      alt="Label Detection"/>
      </div>

      <div className="ComputerVision-card">
      <ServiceMediaCard
      header=" Facial analysis :"
      description=" Get a complete analysis of facial attributes, including confidence scores. "
      imageUrl='https://d2908q01vomqb2.cloudfront.net/c5b76da3e608d34edb07244cd9b875ee86906328/2021/03/04/Liveness-Detection-with-Amazon-Rekognition.png'
      alt="Facial analysis"/>
      </div>

      <div className="ComputerVision-card">
      <ServiceMediaCard
      header=" Facial Image comparison :"
      description=" Compare faces to see how closely they match based on a similarity percentage. "
      imageUrl='https://cloudacademy.com/wp-content/uploads/2016/12/amazon-rekognition-face-comparison.jpg'
      alt="Facial Image comparison"/>
      </div>

      <div className="ComputerVision-card">
      <ServiceMediaCard
      header=" Text Recognition :"
      description=" Detect and Extract Texts in images. "
      imageUrl='https://miro.medium.com/max/667/1*Gxh2zdzDJLRl7ehDKa0xeg.png'
      alt="Text Recognition"/>
      </div>

      </div>
      </body>
      <div className="ComputerVision-trademarks">
      <p> &copy; Copyright 2021 &nbsp; All rights reserved</p>
      <p> Developed by Doge Algo &nbsp; </p>
      </div>
      </div>
  );
}


export default computerVision;
